import type { IconDefinition } from '@fortawesome/sharp-solid-svg-icons';
import { faList, faRefresh } from '@fortawesome/sharp-solid-svg-icons';
export function SCTableRowMenuButton(onClick) {
  return {
    Title: 'Menu',
    Icon: faList,
    OnClick: onClick,
  };
}

export function SCTableRowRefreshButton(onClick, hide?: string) {
  return {
    Title: 'Refresh',
    Icon: faRefresh,
    OnClick: onClick,
    Hidden: hide,
  };
}

export function SCTableRowFieldButton(onClick) {
  return {
    Title: 'Fields',
    Icon: faList,
    OnClick: onClick,
  };
}

//NOTE: icon is type IconDefinition but not working with TS?
export function SCTableRowButton(title: string, icon: IconDefinition, onClick) {
  return {
    Title: title,
    Icon: icon,
    OnClick: onClick,
  };
}
